(function () {
  var root = document.querySelector(".moojo-esperanza");
  if (!root) return;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function tell(iframe, func) {
    if (!iframe || !iframe.contentWindow) return;
    iframe.contentWindow.postMessage('{"event":"command","func":"' + func + '","args":""}', "*");
  }

  var players = [];

  function hush(except) {
    players.forEach(function (player) {
      if (player === except || !player.on) return;
      player.on = false;
      tell(player.frame.querySelector("iframe"), "mute");
      player.btn.textContent = "Activer le son";
      player.btn.setAttribute("aria-pressed", "false");
    });
  }

  function paint(player) {
    player.btn.textContent = player.on ? "Couper le son" : "Activer le son";
    player.btn.setAttribute("aria-pressed", player.on ? "true" : "false");
  }

  function bindFilm(frame, btn, mount) {
    if (!frame || !btn) return null;
    var player = { frame: frame, btn: btn, on: false, playing: false, away: false, mount: mount };
    players.push(player);
    btn.addEventListener("click", function () {
      var iframe = frame.querySelector("iframe");
      if (!iframe) {
        mount(true);
        player.on = true;
        player.playing = true;
        hush(player);
      } else {
        player.on = !player.on;
        tell(iframe, player.on ? "unMute" : "mute");
        if (player.on) {
          tell(iframe, "playVideo");
          player.playing = true;
          player.away = false;
          hush(player);
        }
      }
      paint(player);
    });
    if ("IntersectionObserver" in window) {
      var presence = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var iframe = frame.querySelector("iframe");
          if (!iframe) return;
          if (entry.isIntersecting) {
            if (player.playing && player.away) {
              tell(iframe, "playVideo");
              player.away = false;
            }
            return;
          }
          if (!player.playing) return;
          tell(iframe, "pauseVideo");
          player.away = true;
        });
      }, { threshold: 0.2 });
      presence.observe(frame);
    }
    return player;
  }

  var kuwoi = root.querySelector("#esperanza-kuwoi");
  var kuwoiFrame = kuwoi && kuwoi.querySelector("[data-kuwoi-frame]");
  function mountKuwoi(withSound) {
    if (!kuwoiFrame) return null;
    var existing = kuwoiFrame.querySelector("iframe");
    if (existing) return existing;
    var iframe = document.createElement("iframe");
    var sound = withSound ? "0" : "1";
    var autoplay = reduce ? "0" : "1";
    var kuwoiStart = kuwoiFrame.getAttribute("data-start") || "6";
    iframe.src = "https://www.youtube-nocookie.com/embed/" + kuwoiFrame.getAttribute("data-video") + "?start=" + kuwoiStart + "&autoplay=" + autoplay + "&mute=" + sound + "&playsinline=1&rel=0&enablejsapi=1";
    iframe.title = "Kuwoi Wujan";
    iframe.allow = "autoplay; encrypted-media; picture-in-picture";
    iframe.allowFullscreen = true;
    var cover = kuwoiFrame.querySelector("[data-kuwoi-cover]");
    if (cover) kuwoiFrame.replaceChild(iframe, cover);
    else kuwoiFrame.appendChild(iframe);
    if (kuwoiPlayer) kuwoiPlayer.playing = autoplay === "1" || withSound;
    return iframe;
  }
  var kuwoiPlayer = bindFilm(kuwoiFrame, root.querySelector("[data-kuwoi-sound]"), mountKuwoi);

  var joropoFrame = root.querySelector("[data-joropo-frame]");
  function mountJoropo(withSound) {
    if (!joropoFrame) return null;
    var existing = joropoFrame.querySelector("iframe");
    if (existing) return existing;
    var iframe = document.createElement("iframe");
    var id = joropoFrame.getAttribute("data-video");
    var start = joropoFrame.getAttribute("data-start") || "0";
    var autoplay = reduce ? "0" : "1";
    var sound = withSound ? "0" : "1";
    iframe.src = "https://www.youtube-nocookie.com/embed/" + id
      + "?start=" + start
      + "&autoplay=" + autoplay
      + "&mute=" + sound
      + "&playsinline=1&rel=0&enablejsapi=1";
    iframe.title = "Cimarrón, Orinoco";
    iframe.allow = "autoplay; encrypted-media; picture-in-picture";
    iframe.allowFullscreen = true;
    var poster = joropoFrame.querySelector("img");
    if (poster) joropoFrame.replaceChild(iframe, poster);
    else joropoFrame.appendChild(iframe);
    if (joropoPlayer) joropoPlayer.playing = autoplay === "1" || withSound;
    return iframe;
  }
  var joropoPlayer = bindFilm(joropoFrame, root.querySelector("[data-joropo-sound]"), mountJoropo);

  if (!reduce && "IntersectionObserver" in window) {
    if (joropoFrame) {
      var joropoWatch = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || joropoFrame.querySelector("iframe")) return;
          mountJoropo(false);
          joropoWatch.disconnect();
        });
      }, { threshold: 0.35 });
      joropoWatch.observe(joropoFrame);
    }
    if (kuwoiFrame) {
      var kuwoiWatch = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || kuwoiFrame.querySelector("iframe")) return;
          mountKuwoi(false);
          kuwoiWatch.disconnect();
        });
      }, { threshold: 0.35 });
      kuwoiWatch.observe(kuwoi);
    }
  }

  var expressions = document.querySelector(".shopify-section--related-products .section-header h2");
  if (expressions && expressions.textContent.indexOf("expressions") !== -1 && !expressions.querySelector("em")) {
    expressions.innerHTML = expressions.textContent.replace("expressions", "<em>expressions</em>");
  }

  var harvest = document.querySelector(".moojo-availability--new .moojo-availability__line");
  if (harvest && harvest.textContent.indexOf("attendue") !== -1) {
    harvest.innerHTML = harvest.innerHTML.replace("attendue", "disponible");
  }

  var stickyHarvest = document.querySelector("[data-esperanza-sticky-harvest]");
  if (harvest && stickyHarvest) stickyHarvest.innerHTML = harvest.innerHTML;

  var notify = document.querySelector("moojo-notify");
  if (notify && !document.getElementById("acheter")) notify.id = "acheter";

  var stickyNotify = document.querySelector("[data-esperanza-sticky-notify]");
  if (stickyNotify && stickyNotify.dataset.moojoStickyBound !== "true") {
    stickyNotify.dataset.moojoStickyBound = "true";
    stickyNotify.addEventListener("click", function () {
      var field = document.querySelector("[data-moojo-notify-email]");
      var target = document.getElementById("acheter") || field;
      if (!target) return;
      var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--header-height")) || 106;
      var top = target.getBoundingClientRect().top + window.scrollY - header - 12;
      window.scrollTo({ top: Math.max(0, top), behavior: reduce ? "auto" : "smooth" });
      if (history.replaceState) history.replaceState(null, "", "#acheter");
      if (field) window.setTimeout(function () { field.focus({ preventScroll: true }); }, reduce ? 0 : 350);
    });
  }

  if (reduce) {
    root.setAttribute("data-motion", "reduce");
    return;
  }
  var narrowQuery = window.matchMedia("(max-width: 749px)");
  var videos = root.querySelectorAll("video[data-src]");
  if (!videos.length || !("IntersectionObserver" in window)) return;

  function sourceFor(video) {
    if (narrowQuery.matches) {
      return video.getAttribute("data-src-narrow") || video.getAttribute("data-src");
    }
    return video.getAttribute("data-src");
  }

  function arm(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute("playsinline", "");
    if (!video.getAttribute("src")) {
      video.setAttribute("src", sourceFor(video));
    }
    var started = video.play();
    if (started && started.catch) started.catch(function () {});
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var video = entry.target;
      if (!entry.isIntersecting) {
        if (!video.paused) video.pause();
        return;
      }
      arm(video);
    });
  }, { rootMargin: "240px 0px", threshold: 0.01 });

  videos.forEach(function (video) {
    observer.observe(video);
    var box = video.getBoundingClientRect();
    if (box.width > 0 && box.top < window.innerHeight && box.bottom > 0) arm(video);
  });
})();
